import React, { useEffect, useReducer, useContext, useState } from "react";
import { Store } from "../../Store";
import { getError } from "../../utils/error";
import { viewContactusReducer as reducer } from "../../reducers/contactus";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Card, Col, Container, Row } from "react-bootstrap";
import MessageBox from "../layout/MessageBox";
import axiosInstance from "../../utils/axiosUtil";
import { FaEdit } from "react-icons/fa";
import { motion } from "framer-motion";
import Skeleton from "react-loading-skeleton";

const ViewDetails = () => {
  const { state } = useContext(Store);
  const { token } = state;
  const { id } = useParams(); // category/:id

  const [modalShow, setModalShow] = useState(false);
  const [{ loading, error, contactus }, dispatch] = useReducer(reducer, {
    loading: true,
    error: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch({ type: "FETCH_REQUEST" });

        const { data } = await axiosInstance.get(
          `/api/admin/view-contactus/${id}`,
          {
            headers: { Authorization: token },
          }
        );

        dispatch({ type: "FETCH_SUCCESS", payload: data?.getContactus[0] });
      } catch (err) {
        dispatch({
          type: "FETCH_FAIL",
          payload: getError(err),
        });
        toast.error(getError(err), {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    fetchData();
  }, [id]);

  const getDateTime = (dt) => {
    const dT = dt.split(".")[0].split("T");
    return `${dT[0]} ${dT[1]}`;
  };

  return (
    <motion.div
      initial={{ x: "100%" }}
      animate={{ x: "0%" }}
      transition={{ duration: 0.75, ease: "easeInOut" }}
      exit={{ x: "100%" }}
    >
      <Container fluid className="py-3">
        {error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <>
            <Card>
              <Card.Header>
                <Card.Title>
                  {loading ? (
                    <Skeleton />
                  ) : (
                    contactus?.firstname + " " + contactus?.lastname
                  )}{" "}
                  Query
                </Card.Title>

                {/* <div className="card-tools">
                  <FaEdit
                    style={{ color: "blue" }}
                    onClick={() => setModalShow(true)}
                  />
                </div> */}
              </Card.Header>
              <Card.Body>
                <Row className="mb-3">
                  <Col md={8}>
                    <Row>
                      <Col md={4}>
                        <p className="mb-0">
                          <strong>First name</strong>
                        </p>
                        <p>{loading ? <Skeleton /> : contactus?.firstname}</p>
                      </Col>
                      <Col md={4}>
                        <p className="mb-0">
                          <strong>Last name</strong>
                        </p>
                        <p>{loading ? <Skeleton /> : contactus?.lastname}</p>
                      </Col>
                      <Col md={4}>
                        <p className="mb-0">
                          <strong>Email</strong>
                        </p>
                        <p>{loading ? <Skeleton /> : contactus?.email}</p>
                      </Col>
                      <Col md={4}>
                        <p className="mb-0">
                          <strong>Mobile</strong>
                        </p>
                        <p>{loading ? <Skeleton /> : contactus?.mobile_no}</p>
                      </Col>
                      <Col md={4}>
                        <p className="mb-0">
                          <strong>Topic</strong>
                        </p>
                        <p>{loading ? <Skeleton /> : contactus?.topic}</p>
                      </Col>
                      <Col md={4}>
                        <p className="mb-0">
                          <strong>Message</strong>
                        </p>
                        <p>{loading ? <Skeleton /> : contactus?.message}</p>
                      </Col>
                      <Col md={4}>
                        <p className="mb-0">
                          <strong>Created At</strong>
                        </p>
                        <p>
                          {loading ? (
                            <Skeleton />
                          ) : (
                            getDateTime(contactus?.createdAt)
                          )}
                        </p>
                      </Col>
                      <Col md={4}>
                        <p className="mb-0">
                          <strong>Last Update</strong>
                        </p>
                        <p>
                          {loading ? (
                            <Skeleton />
                          ) : (
                            getDateTime(contactus?.updatedAt)
                          )}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <ToastContainer />
          </>
        )}
      </Container>
    </motion.div>
  );
};

export default ViewDetails;
